import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractWidgetComponent, AppClientConfiguration, AppServerAPI, ComponentSelectionStorageService, ContextChange } from '@sdbn/common';
import { Subscription, interval } from 'rxjs';
import { StructureNode } from '../../../../components/structure-node-selection/structure-node-selection.model';
import { Timeframe } from './../model/timeframe';

const SELECTED_STRUCTURE_NODE = 'timeframe-usage.selected.structure-node';

/**
 * DTO to request Data.
 */
export class TimeframeSelection {
  date: Date;
  mode: string;
  stationGroupId: number;
  stationSetId: number;
}

export class TimeFrameGroup {
  timeframes: Timeframe[] = [];
}


@Component({
  selector: 'app-timeframe-usage',
  templateUrl: './timeframe-usage.component.html',
  styleUrls: ['./timeframe-usage.component.scss']
})
export class TimeframeUsageComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  private ONE_DAY_DURATION: number = 24 * 60 * 60 * 1000;

  selectedDate = new Date();

  timeframes: Timeframe[] = [];

  timeframeGroups: TimeFrameGroup[] = [];

  private selectedMode = 'sums';

  selectedStructureNode: StructureNode;

  refreshEnabled = true;
  refreshInterval = 30000;
  refreshTimer: Subscription;

  constructor(
    private componentSelectionStorageService: ComponentSelectionStorageService,
    private appServerAPI: AppServerAPI,
    private appClientConfiguration: AppClientConfiguration) {
    super();
    this.selectedStructureNode = componentSelectionStorageService.get(SELECTED_STRUCTURE_NODE);

  }

  ngOnInit() {
    this.loadTimeFrames();
  }

  ngOnDestroy() {

    super.ngOnDestroy();

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }
  }

  public getTimeframesForColumn1(): Timeframe[] {
    return this.timeframes.filter(tf => tf.index < 12);
  }

  public getTimeframesForColumn2(): Timeframe[] {
    return this.timeframes.filter(tf => tf.index >= 12);
  }

  public back() {
    this.selectedDate = new Date(this.selectedDate.getTime() - this.ONE_DAY_DURATION);
    this.loadTimeFrames();
  }

  public forward() {
    this.selectedDate = new Date(this.selectedDate.getTime() + this.ONE_DAY_DURATION);
    this.loadTimeFrames();
  }

  public onSelectedStructureChanged(structureNode: StructureNode) {
    this.componentSelectionStorageService.save(SELECTED_STRUCTURE_NODE, structureNode);
    this.selectedStructureNode = structureNode;
    this.loadTimeFrames();
  }

  private loadTimeFrames() {

    this.timeframes = [];

    const selection = new TimeframeSelection();
    selection.date = this.selectedDate;
    selection.mode = this.selectedMode;
    selection.stationGroupId = this.selectedStructureNode?.stationGroupId;
    selection.stationSetId = this.selectedStructureNode?.stationSetId;

    this.appServerAPI.execute<Timeframe[]>('/client/control/timeframe-usage/timeframes', selection).subscribe(
      result => {
        this.timeframes = result;
        this.groupResults();
      }, error => {
        console.error('Error loading timeframes');
      }
    );
  }

  private groupResults() {

    let timeframeGroup = null;
    this.timeframeGroups = [];

    for (let i = 0; i < 24; i++) {
      if (i % 4 == 0) {
        timeframeGroup = new TimeFrameGroup();
        this.timeframeGroups.push(timeframeGroup);
      }
      timeframeGroup.timeframes.push(...this.timeframes.filter(tf => tf.index == i));
    }

  }

  public isModeSelected(mode: string): boolean {
    return this.selectedMode === mode;
  }

  public selectMode(mode: string) {
    this.selectedMode = mode;
    this.loadTimeFrames();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    console.log('onSetElementAndContext', this.widgetReference);
    this.refreshEnabled = this.widgetReference.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 30 * 1000;
    }
    this.registerRefreshTimer();
  }

  private registerRefreshTimer() {

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }

    if (this.appClientConfiguration.autoreload && this.refreshEnabled) {
      this.refreshTimer = interval(this.refreshInterval).subscribe(() => {
        this.loadTimeFrames();
      }
      );
    } else {
      console.log('Autoreload timeframe-usage disabled');
    }
  }
}
